import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import SelectBoxItemViewModelType from '@/ViewModels/Controls/SelectBoxItemViewModel';
import CheckBoxType from '@/Controls/CheckBox';

export default class SelectBoxItem extends Control {

    private CheckBox = ComponentManager.getControl<typeof CheckBoxType>('CheckBox');
    private jQueryControl: JQuery;
    private checkBox: CheckBoxType;

    public constructor(private viewModel: SelectBoxItemViewModelType, private element?: JQuery) {
        super(viewModel, element);
        
        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<li>');

        this.widget(null);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'selectboxitem',

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            visible: this.viewModel.isVisible,

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.checkBox.isChecked() === true) {
                        states.push('selected');
                    }

                    return states;
                }
            }),

            attr: {
                'data-value': this.definePureComputed({
                    read: () => {
                        return this.viewModel.value();
                    }
                })
            }
        });

        if (this.viewModel.checkBox != null) {
            this.checkBox = new this.CheckBox(this.viewModel.checkBox);
            let tuple = this.checkBox.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('SelectBoxItem', SelectBoxItem, 'RADPresentation.HTMLClient.DefaultViewExtensions');